import API from "../../helpers/network/http";
import {SongRequest} from "../../utils/types";


export default class SongRequestService {
    // Create a method to create a song request
    static async createSongRequest(payload: Partial<SongRequest>) {
        // Call the register endpoint from the API
        const {data} = await API.post("/song-requests", payload);

        // Return the response
        return data.data;
    }

    // Method to get a user's song requests
    static async getSongRequests(): Promise<SongRequest[]> {
        // Call the login endpoint from the API
        const {data} = await API.get("/song-requests");

        // Return the response
        return data.data;
    }

    // Method to vote on a song request
    static async voteSongRequest(id: number) {
        // Call the login endpoint from the API
        const {data} = await API.get(`/song-requests/${id}`);

        // Return the response
        return data.data;
    }
}